import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Grid, Paper, Typography, Tab, Tabs } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import 'react-datepicker/dist/react-datepicker.css';

import {
    getBpMembers,
    getAdultHealthMembers,
    getBmiMembers,
    getBreastCancerScreeningMembers,
    getHgbA1CMembers,
    getDiabeticEyeExamMembers,
    getMedicationReconciliationMembers,
    getDepressionScreeningMembers,
    getDepressionFollowUpMembers,
    getLipidForBHDXMembers,
    getHgbA1CForBHDXMembers,
    getCervicalCancerScreeningMembers,
    getColorectalCancerScreeningMembers,
    getBhDiagnosticMembers,
} from './HedisMetricService';
import HedisMetricsMembers from '../../Models/HedisMetrics/HedisMetricsMembersDto.model';
import BhDiagnosticSummary from '../../Models/HedisMetrics/BhDiagnosticSummary.model';
import { TimePeriodFilterEnum } from '../../Enum/TimePeriodFilterEnum';
import { useHedisMetricsContext } from '../../hooks/hedisMetricsContext';
import FilterOptions from './FilterOptions';
import HedisDataGrid from './HedisDataGrid';
import '../Widgets/Widgets.css';

const HedisMemberDetail = (props: any) => {
    const history = useNavigate();
    const {
        healthPlans,
        setHealthPlans,
        population,
        setPopulation,
        team,
        setTeam,
        filter,
        setFilter,
        fDate,
        setFDate,
        tDate,
        setTDate,
        includePastOpenStatus,
        setIncludePastOpenStatus,
        showInActiveTeam,
        setShowInActiveTeam,
        hasElevatedFilterAccess,
        setHasElevatedFilterAccess,

        setAdultHealthHealthPlans,
        setAdultHealthTeam,
        setAdultHealthDateFilter,
        setAdultHealthFromDate,
        setAdultHealthToDate,
        setAdultHealthIncludePastOpenStatus,
        setAdultHealthShowInActiveTeam,

        setBpHealthPlans,
        setBpPopulation,
        setBpTeam,
        setBpDateFilter,
        setBpFromDate,
        setBpToDate,
        setBpIncludePastOpenStatus,
        setBpShowInActiveTeam,

        setBmiHealthPlans,
        setBmiTeam,
        setBmiDateFilter,
        setBmiFromDate,
        setBmiToDate,
        setBmiIncludePastOpenStatus,
        setBmiShowInActiveTeam,

        setBreastCancerScreeningHealthPlans,
        setBreastCancerScreeningTeam,
        setBreastCancerScreeningDateFilter,
        setBreastCancerScreeningFromDate,
        setBreastCancerScreeningToDate,
        setBreastCancerScreeningIncludePastOpenStatus,
        setBreastCancerScreeningShowInActiveTeam,

        setHgba1cHealthPlans,
        setHgba1cPopulation,
        setHgba1cTeam,
        setHgba1cDateFilter,
        setHgba1cFromDate,
        setHgba1cToDate,
        setHgba1cIncludePastOpenStatus,
        setHgba1cShowInActiveTeam,

        setDiabeticEyeExamHealthPlans,
        setDiabeticEyeExamTeam,
        setDiabeticEyeExamDateFilter,
        setDiabeticEyeExamFromDate,
        setDiabeticEyeExamToDate,
        setDiabeticEyeExamIncludePastOpenStatus,
        setDiabeticEyeExamShowInActiveTeam,

        setMedicationReconciliationHealthPlans,
        setMedicationReconciliationTeam,
        setMedicationReconciliationDateFilter,
        setMedicationReconciliationFromDate,
        setMedicationReconciliationToDate,
        setMedicationReconciliationIncludePastOpenStatus,
        setMedicationReconciliationShowInActiveTeam,

        setDepressionScreeningHealthPlans,
        setDepressionScreeningTeam,
        setDepressionScreeningDateFilter,
        setDepressionScreeningFromDate,
        setDepressionScreeningToDate,
        setDepressionScreeningIncludePastOpenStatus,
        setDepressionScreeningShowInActiveTeam,

        setDepressionFollowUpHealthPlans,
        setDepressionFollowUpTeam,
        setDepressionFollowUpDateFilter,
        setDepressionFollowUpFromDate,
        setDepressionFollowUpToDate,
        setDepressionFollowUpIncludePastOpenStatus,
        setDepressionFollowUpShowInActiveTeam,

        setLipidForBhDxHealthPlans,
        setLipidForBhDxTeam,
        setLipidForBhDxDateFilter,
        setLipidForBhDxFromDate,
        setLipidForBhDxToDate,
        setLipidForBhDxIncludePastOpenStatus,
        setLipidForBhDxShowInActiveTeam,

        setHgbA1cForBhDxHealthPlans,
        setHgbA1cForBhDxTeam,
        setHgbA1cForBhDxDateFilter,
        setHgbA1cForBhDxFromDate,
        setHgbA1cForBhDxToDate,
        setHgbA1cForBhDxIncludePastOpenStatus,
        setHgbA1cForBhDxShowInActiveTeam,

        setColorectalCancerScreeningHealthPlans,
        setColorectalCancerScreeningTeam,
        setColorectalCancerScreeningDateFilter,
        setColorectalCancerScreeningFromDate,
        setColorectalCancerScreeningToDate,
        setColorectalCancerScreeningIncludePastOpenStatus,
        setColorectalCancerScreeningShowInActiveTeam,

        setCervicalCancerScreeningHealthPlans,
        setCervicalCancerScreeningTeam,
        setCervicalCancerScreeningDateFilter,
        setCervicalCancerScreeningFromDate,
        setCervicalCancerScreeningToDate,
        setCervicalCancerScreeningIncludePastOpenStatus,
        setCervicalCancerScreeningShowInActiveTeam,

        setBhDiagnosticHealthPlans,
        setBhDiagnosticTeam,
        setBhDiagnosticDateFilter,
        setBhDiagnosticFromDate,
        setBhDiagnosticToDate,
        setBhDiagnosticIncludePastOpenStatus,
        setBhDiagnosticShowInActiveTeam,
    } = useHedisMetricsContext();
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [isMembersLoading, setIsMembersLoading] = useState<boolean>(false);
    const [members, setMembers] = useState<HedisMetricsMembers>();
    const [bhDiagnostic, setBhDiagnostic] = useState<BhDiagnosticSummary>();
    const [headerName, setHeaderName] = useState<string>();
    const params = useParams();
    const hedisType = params?.type;

    const [tab, setTab] = useState(1);

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTab(newValue);
    };

    const initialPage = useCallback(async () => {
        if (isFetched) {
            return;
        }
    }, [isFetched]);

    useEffect(() => {
        initialPage();
    }, [initialPage]);

    useEffect(() => {
        if (filter !== TimePeriodFilterEnum.Custom || (Boolean(fDate) && Boolean(tDate))) {
            const changeFilter = async () => {
                setIsMembersLoading(false);
                let data = null;
                let start = fDate !== null ? new Date(fDate).toDateString() : null;
                let end = tDate !== null ? new Date(tDate).toDateString() : null;
                switch (hedisType) {
                    case 'BP':
                        setHeaderName('BP Members');
                        data = await getBpMembers(healthPlans, population, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setBpHealthPlans(healthPlans);
                        setBpPopulation(population);
                        setBpTeam(team);
                        setBpDateFilter(filter);
                        setBpFromDate(fDate);
                        setBpToDate(tDate);
                        setBpIncludePastOpenStatus(includePastOpenStatus);
                        setBpShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'ProviderVisits':
                        setHeaderName('Adult Health Members');
                        data = await getAdultHealthMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setAdultHealthHealthPlans(healthPlans);
                        setAdultHealthTeam(team);
                        setAdultHealthDateFilter(filter);
                        setAdultHealthFromDate(fDate);
                        setAdultHealthToDate(tDate);
                        setAdultHealthIncludePastOpenStatus(includePastOpenStatus);
                        setAdultHealthShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'BMI':
                        setHeaderName('BMI Members');
                        data = await getBmiMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setBmiHealthPlans(healthPlans);
                        setBmiTeam(team);
                        setBmiDateFilter(filter);
                        setBmiFromDate(fDate);
                        setBmiToDate(tDate);
                        setBmiIncludePastOpenStatus(includePastOpenStatus);
                        setBmiShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'BreastCancerScreening':
                        setHeaderName('Breast Cancer Screening Members');
                        data = await getBreastCancerScreeningMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setBreastCancerScreeningHealthPlans(healthPlans);
                        setBreastCancerScreeningTeam(team);
                        setBreastCancerScreeningDateFilter(filter);
                        setBreastCancerScreeningFromDate(fDate);
                        setBreastCancerScreeningToDate(tDate);
                        setBreastCancerScreeningIncludePastOpenStatus(includePastOpenStatus);
                        setBreastCancerScreeningShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'HgbA1C':
                        setHeaderName('HgbA1C Members');
                        data = await getHgbA1CMembers(healthPlans, population, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setHgba1cHealthPlans(healthPlans);
                        setHgba1cPopulation(population);
                        setHgba1cTeam(team);
                        setHgba1cDateFilter(filter);
                        setHgba1cFromDate(fDate);
                        setHgba1cToDate(tDate);
                        setHgba1cIncludePastOpenStatus(includePastOpenStatus);
                        setHgba1cShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'DiabeticEyeExam':
                        setHeaderName('Diabetic Eye Exam Members');
                        data = await getDiabeticEyeExamMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setDiabeticEyeExamHealthPlans(healthPlans);
                        setDiabeticEyeExamTeam(team);
                        setDiabeticEyeExamDateFilter(filter);
                        setDiabeticEyeExamFromDate(fDate);
                        setDiabeticEyeExamToDate(tDate);
                        setDiabeticEyeExamIncludePastOpenStatus(includePastOpenStatus);
                        setDiabeticEyeExamShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'MedicationReconciliation':
                        setHeaderName('Medication Reconciliation Post Discharge Members');
                        data = await getMedicationReconciliationMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setMedicationReconciliationHealthPlans(healthPlans);
                        setMedicationReconciliationTeam(team);
                        setMedicationReconciliationDateFilter(filter);
                        setMedicationReconciliationFromDate(fDate);
                        setMedicationReconciliationToDate(tDate);
                        setMedicationReconciliationIncludePastOpenStatus(includePastOpenStatus);
                        setMedicationReconciliationShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'DepressionScreening':
                        setHeaderName('Depression Screening Members');
                        data = await getDepressionScreeningMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setDepressionScreeningHealthPlans(healthPlans);
                        setDepressionScreeningTeam(team);
                        setDepressionScreeningDateFilter(filter);
                        setDepressionScreeningFromDate(fDate);
                        setDepressionScreeningToDate(tDate);
                        setDepressionScreeningIncludePastOpenStatus(includePastOpenStatus);
                        setDepressionScreeningShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'DepressionFollowUp':
                        setHeaderName('Depression Followup Members');
                        data = await getDepressionFollowUpMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setDepressionFollowUpHealthPlans(healthPlans);
                        setDepressionFollowUpTeam(team);
                        setDepressionFollowUpDateFilter(filter);
                        setDepressionFollowUpFromDate(fDate);
                        setDepressionFollowUpToDate(tDate);
                        setDepressionFollowUpIncludePastOpenStatus(includePastOpenStatus);
                        setDepressionFollowUpShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'LipidForBhDx':
                        setHeaderName('Lipid for BH DX Members');
                        data = await getLipidForBHDXMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setLipidForBhDxHealthPlans(healthPlans);
                        setLipidForBhDxTeam(team);
                        setLipidForBhDxDateFilter(filter);
                        setLipidForBhDxFromDate(fDate);
                        setLipidForBhDxToDate(tDate);
                        setLipidForBhDxIncludePastOpenStatus(includePastOpenStatus);
                        setLipidForBhDxShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'HgbA1cForBhDx':
                        setHeaderName('HgbA1C for BH DX Members');
                        data = await getHgbA1CForBHDXMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setHgbA1cForBhDxHealthPlans(healthPlans);
                        setHgbA1cForBhDxTeam(team);
                        setHgbA1cForBhDxDateFilter(filter);
                        setHgbA1cForBhDxFromDate(fDate);
                        setHgbA1cForBhDxToDate(tDate);
                        setHgbA1cForBhDxIncludePastOpenStatus(includePastOpenStatus);
                        setHgbA1cForBhDxShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'CervicalCancerScreening':
                        setHeaderName('Cervical Cancer Screening Members');
                        data = await getCervicalCancerScreeningMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setCervicalCancerScreeningHealthPlans(healthPlans);
                        setCervicalCancerScreeningTeam(team);
                        setCervicalCancerScreeningDateFilter(filter);
                        setCervicalCancerScreeningFromDate(fDate);
                        setCervicalCancerScreeningToDate(tDate);
                        setCervicalCancerScreeningIncludePastOpenStatus(includePastOpenStatus);
                        setCervicalCancerScreeningShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'ColorectalCancerScreening':
                        setHeaderName('Colorectal Cancer Screening Members');
                        data = await getColorectalCancerScreeningMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setColorectalCancerScreeningHealthPlans(healthPlans);
                        setColorectalCancerScreeningTeam(team);
                        setColorectalCancerScreeningDateFilter(filter);
                        setColorectalCancerScreeningFromDate(fDate);
                        setColorectalCancerScreeningToDate(tDate);
                        setColorectalCancerScreeningIncludePastOpenStatus(includePastOpenStatus);
                        setColorectalCancerScreeningShowInActiveTeam(showInActiveTeam);
                        break;
                    case 'BHDiagnostic':
                        setHeaderName('BH Diagnostic Members');
                        data = await getBhDiagnosticMembers(healthPlans, team, filter, start, end, includePastOpenStatus, showInActiveTeam);
                        setBhDiagnosticHealthPlans(healthPlans);
                        setBhDiagnosticTeam(team);
                        setBhDiagnosticDateFilter(filter);
                        setBhDiagnosticFromDate(fDate);
                        setBhDiagnosticToDate(tDate);
                        setBhDiagnosticIncludePastOpenStatus(includePastOpenStatus);
                        setBhDiagnosticShowInActiveTeam(showInActiveTeam);
                        setBhDiagnostic(data);
                        break;
                }
                setMembers(data);
                setIsFetched(true);
                setIsMembersLoading(true);
            };
            if (healthPlans.length > 0) changeFilter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [healthPlans, population, hedisType, team, filter, fDate, tDate, includePastOpenStatus, showInActiveTeam]);

    const navigateToGraph = () => {
        history('/provider/metricsummary/smart-dashboard');
    };

    return (
        <Paper elevation={5}>
            <Grid container spacing={2} paddingLeft={2} paddingRight={2} paddingTop={1}>
                <Grid size={12} paddingBottom={1} display={'flex'} alignItems={'center'}>
                    <span onClick={navigateToGraph}>
                        <ArrowBackIcon className="pointer" style={{ color: 'black', marginRight: 2 }} titleAccess="Back" />
                    </span>
                    <Typography display={'inline-block'} variant="h6" color={'primary'}>
                        {headerName}
                    </Typography>
                </Grid>
                <FilterOptions
                    selectedTeam={team}
                    setSelectedTeam={setTeam}
                    dateFilter={filter}
                    setDateFilter={setFilter}
                    fromDate={fDate}
                    setFromDate={setFDate}
                    toDate={tDate}
                    setToDate={setTDate}
                    healthPlan={healthPlans}
                    setHealthPlan={setHealthPlans}
                    pop={population}
                    setPop={setPopulation}
                    includePastOpenStatusMembers={includePastOpenStatus}
                    setIncludePastOpenStatusMembers={setIncludePastOpenStatus}
                    isDetailPage={true}
                    hedisType={hedisType}
                    showInActiveTeams={showInActiveTeam}
                    setShowInActiveTeams={setShowInActiveTeam}
                    hasElevatedFilterAccess={hasElevatedFilterAccess}
                    setHasElevatedFilterAccess={setHasElevatedFilterAccess}
                />
            </Grid>
            <hr />
            <Grid container spacing={2} paddingLeft={2} paddingRight={2} paddingBottom={2}>
                <Grid size={12} minHeight="60vh" sx={{ position: 'relative' }}>
                    {!isMembersLoading ? (
                        <Box className="loader-center">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            {(() => {
                                switch (hedisType) {
                                    case 'BP':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Controlled ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Controlled ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'ProviderVisits':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Visits Completed ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            No Visits ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'BMI':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            BMI Completed ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            No BMI Documented ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'BreastCancerScreening':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Screened ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Screened ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'HgbA1C':
                                        return (
                                            <>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Controlled ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Controlled ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Documented ({members.OtherMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.OtherMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'DiabeticEyeExam':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Screened ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Screened ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'MedicationReconciliation':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Documented ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaMetMembers}
                                                            hedisType="MedicationReconciliation"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Documented ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaNotMetMembers}
                                                            hedisType="MedicationReconciliation"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'DepressionScreening':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Met ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaMetMembers}
                                                            hedisType="DepressionScreening"
                                                            status="Met"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Met ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaNotMetMembers}
                                                            hedisType="DepressionScreening"
                                                            status="Not Met"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'DepressionFollowUp':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Met ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaMetMembers}
                                                            hedisType="DepressionFollowUp"
                                                            status="Met"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Met ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid
                                                            memberList={members.CriteriaNotMetMembers}
                                                            hedisType="DepressionFollowUp"
                                                            status="Not Met"
                                                        ></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'LipidForBhDx':
                                        return (
                                            <>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Controlled ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Controlled ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Documented ({members.OtherMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.OtherMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'HgbA1cForBhDx':
                                        return (
                                            <>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Controlled ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Controlled ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={4}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Documented ({members.OtherMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.OtherMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'CervicalCancerScreening':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Screened ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Screened ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'ColorectalCancerScreening':
                                        return (
                                            <>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Screened ({members.CriteriaMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Grid size={12} textAlign="center">
                                                        <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                            Not Screened ({members.CriteriaNotMetMembers.length})
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                        <HedisDataGrid memberList={members.CriteriaNotMetMembers}></HedisDataGrid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        );
                                    case 'BHDiagnostic':
                                        return (
                                            <>
                                                <Grid size={10} display={'flex'} mb={2}>
                                                    <Tabs sx={{ display: 'inline-flex', marginRight: 'auto' }} value={tab} onChange={handleTabChange}>
                                                        <Tab value={1} label="All" />
                                                        <Tab value={2} label="Primary BH" />
                                                        <Tab value={3} label="SMI" />
                                                    </Tabs>
                                                </Grid>
                                                {tab === 1 ? (
                                                    <>
                                                        <Grid size={6} sx={{ marginBottom: '25px' }}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Completed ({bhDiagnostic.BhAssessmentCompletedMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentCompletedMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid size={6}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Not Completed ({bhDiagnostic.BhAssessmentNotCompletedMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentNotCompletedMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                ) : tab === 2 ? (
                                                    <>
                                                        <Grid size={6} sx={{ marginBottom: '25px' }}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Completed ({bhDiagnostic.BhAssessmentCompletedForPrimaryBhMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentCompletedForPrimaryBhMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid size={6}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Not Completed ({bhDiagnostic.BhAssessmentNotCompletedForPrimaryBhMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentNotCompletedForPrimaryBhMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Grid size={6} sx={{ marginBottom: '25px' }}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Completed ({bhDiagnostic.BhAssessmentCompletedForSMIMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentCompletedForSMIMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid size={6}>
                                                            <Grid size={12} textAlign="center">
                                                                <Typography display={'inline-block'} variant="h6" color={'primary'}>
                                                                    Not Completed ({bhDiagnostic.BhAssessmentNotCompletedForSMIMembers.length})
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={12} style={{ height: '67vh', width: '100%' }}>
                                                                <HedisDataGrid
                                                                    memberList={bhDiagnostic.BhAssessmentNotCompletedForSMIMembers}
                                                                    hedisType="BHDiagnostic"
                                                                ></HedisDataGrid>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )}
                                            </>
                                        );
                                }
                            })()}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default HedisMemberDetail;
